<template>
  <div class="mx-auto max-w-md p-6 flex-1 self-center mb-32">
    <div class="py-6">
      <Logo height="26" class="mx-auto" />
    </div>
    <h1 class="py-4 text-lg">{{ title }}</h1>
    <Form action="/password/reset" :form-data="form" @success="success">
      <template v-slot="{ errors, submitting }">
        <label class="block mb-5">
          <span class="mb-1 block">E-mailadres</span>
          <BaseInput
            name="email"
            v-model="form.email"
            :error="errors.email"
            :placeholder="placeholder"
            type="email"
            required
            v-focus="!form.email"
          />
          <div class="text-sm text-gray-500 mt-1" v-if="firstTimeUser">{{ placeholder }}</div>
        </label>
        <label class="block mb-5">
          <span class="mb-1 block">{{ label }}</span>
          <BaseInput
            name="password"
            v-model="form.password"
            :error="errors.password"
            type="password"
            required
            v-focus="!!form.email"
          />
          <div class="text-sm text-gray-500 mt-1">Minimaal 8 tekens</div>
        </label>
        <label class="block mb-5">
          <span class="mb-1 block">{{ label }} herhalen</span>
          <BaseInput
            name="password_confirmation"
            v-model="form.password_confirmation"
            :error="errors.password_confirmation"
            type="password"
            required
          />
        </label>
        <div class="flex mt-5">
          <button type="submit" :disabled="submitting" class="btn btn-blue">{{ buttonText }}</button>
        </div>
      </template>
    </Form>
  </div>
</template>

<script>
import auth from "@/auth";
import Logo from "@/components/Logo";
import Form from "@/components/Form";

export default {
  components: {
    Logo,
    Form
  },

  props: {
    firstTimeUser: Boolean
  },

  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        token: this.$route.params.token
      }
    };
  },

  computed: {
    title() {
      return this.firstTimeUser
        ? "Kies je wachtwoord"
        : "Kies een nieuw wachtwoord";
    },

    placeholder() {
      return this.firstTimeUser
        ? "E-mailadres waarop je bent uitgenodigd"
        : "E-mailadres waarmee je inlogt";
    },

    label() {
      return this.firstTimeUser ? "Wachtwoord" : "Nieuw wachtwoord";
    },

    buttonText() {
      return this.firstTimeUser ? "Opslaan en inloggen" : "Reset wachtwoord";
    }
  },

  created() {
    auth.csrf();

    if (sessionStorage.getItem("email")) {
      this.form.email = sessionStorage.getItem("email");
    }

    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
  },

  methods: {
    success() {
      let message = this.firstTimeUser
        ? "Je wachtwoord is opgeslagen!"
        : "Je nieuwe wachtwoord is opgeslagen!";

      this.$store.commit("FLASH_ADD", { message });

      this.$router.push({ name: "dashboard" });

      sessionStorage.removeItem("email");
    }
  }
};
</script>
